import { render, staticRenderFns } from "./committeeContent.vue?vue&type=template&id=96ca79c2"
import script from "./committeeContent.vue?vue&type=script&lang=js"
export * from "./committeeContent.vue?vue&type=script&lang=js"
import style0 from "./committeeContent.vue?vue&type=style&index=0&id=96ca79c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_7d97cc52897b1b5edd1ee8818c6a75fc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports